import React from "react";
import "./style.css";

const Circle = () => {
  return <div className="circle"></div>;
};

export default Circle;
